import { Grid, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import Input from './Input';
import CustomButton from './Button';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import PropTypes from 'prop-types';
import { style } from 'constant/constants';
import { formatTier } from 'utils/utils';
import LogoInput from 'pages/storePages/LogoInput';

const InputFields = [
  {
    name: 'storeName',
    label: 'Store Name',
    type: 'text',
    maxLength: 149,
    placeholder: 'Enter store name',
    required: true
  },

  {
    name: 'contactName',
    label: 'Contact Name',
    type: 'text',
    maxLength: 149,
    placeholder: 'Enter contact name',
    required: true
  },

  {
    name: 'email',
    label: 'Email',
    type: 'email',
    maxLength: 50,
    placeholder: 'Enter email',
    required: true
  },

  {
    name: 'phone1',
    label: 'Phone 1',
    type: 'text',
    maxLength: 20,
    placeholder: 'Enter phone',
    required: true
  },

  {
    name: 'phone2',
    label: 'Phone 2',
    type: 'text',
    maxLength: 20,
    placeholder: 'Enter phone',
    required: false
  },

  {
    name: 'address',
    label: 'Address',
    type: 'text',
    maxLength: 245,
    placeholder: 'Enter address',
    required: true
  }
];

const StoreForm = ({
  store,
  storeInfo,
  buttonText,
  buttonClose,
  handleSubmit,
  handleCancelAction,
  handleStoreInfo,
  error,
  handleError,
  tiers,
  handleTierChange,
  handleBasePriceTypeChange,
  value,
  isSaved
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Grid container sx={{ width: '100vh' }}>
        {InputFields.map(({ name, type, placeholder, label, required, maxLength }) => (
          <Grid item xs={6} key={name} sx={{ marginTop: '3vh' }}>
            <Input
              type={type}
              placeholder={placeholder}
              onChange={handleStoreInfo}
              value={storeInfo[name]}
              required={required}
              label={label}
              onFocus={() => handleError(name, null)}
              name={name}
              maxLength={maxLength}
              multiline={name == 'address'}
              rows={1}
              error={error[name]}
            />
          </Grid>
        ))}
        <Grid item xs={6} key="storeLogo" sx={{ mt: '3vh', backgroudColor: 'red', width: 200 }}>
          <LogoInput
            handleStoreInfo={handleStoreInfo}
            handleError={handleError}
            error={error}
            store={store}
            isSaved={isSaved}
          />
        </Grid>
        <Grid>
          <Grid item xs={12} sx={{ ml: '5vh', mt: '3vh', width: '100%' }}>
            <InputLabel
              htmlFor="demo-simple-select-label"
              sx={{
                fontFamily: style.fontFamily,
                color: style.LIGHT.primary
              }}>
              Select Base Price
            </InputLabel>
            <Select
              size="small"
              id="type-select"
              sx={{ width: '40vh', fontFamily: style.fontFamily, mt: 0, mb: -2 }}
              onChange={handleBasePriceTypeChange}
              name="type"
              value={storeInfo?.currentBasePriceTypeId ?? 0}>
              {storeInfo?.basePriceTypes &&
                storeInfo?.basePriceTypes.map((type) => (
                  <MenuItem key={type.basePriceTypeId} value={type.basePriceTypeId}>
                    {formatTier(type.basePriceType)}
                  </MenuItem>
                ))}
            </Select>
          </Grid>
          <Grid item xs={12} sx={{ ml: '5vh', mt: '3vh', width: '100%' }}>
            <InputLabel
              htmlFor="demo-simple-select-label"
              sx={{
                fontFamily: style.fontFamily,
                color: style.LIGHT.primary
              }}>
              Select Tier
            </InputLabel>
            <Select
              size="small"
              id="tier-select"
              sx={{ width: '40vh', fontFamily: style.fontFamily, mt: 0, mb: -2 }}
              onChange={handleTierChange}
              name="tier"
              defaultValue={value}>
              {tiers.map((tier) => (
                <MenuItem key={tier.value} value={tier.value}>
                  {formatTier(tier.label)}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
      </Grid>

      <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ mr: '5vh' }}>
        {/* add more button will not show in case of edit */}
        {!store?.id && (
          <CustomButton
            sx={{ ml: '15vh' }}
            type="submit"
            onClick={handleSubmit}
            endIcon={buttonText === 'Save' ? <SaveIcon /> : <AddIcon />}>
            {buttonText}
          </CustomButton>
        )}
        {buttonText !== 'Save' && (
          <CustomButton type="button" endIcon={<SaveIcon />} onClick={handleCancelAction}>
            {store?.id ? 'Save' : buttonClose}
          </CustomButton>
        )}
      </Stack>
    </form>
  );
};

StoreForm.propTypes = {
  store: PropTypes.object,
  storeInfo: PropTypes.object,
  buttonText: PropTypes.string,
  buttonClose: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleCancelAction: PropTypes.func,
  handleStoreInfo: PropTypes.func,
  handleError: PropTypes.func,
  disableEmail: PropTypes.bool,
  isBulkUpload: PropTypes.bool,
  error: PropTypes.object,
  tiers: PropTypes.array,
  handleTierChange: PropTypes.func,
  handleBasePriceTypeChange: PropTypes.func,
  value: PropTypes.number,
  editMode: PropTypes.bool,
  isSaved: PropTypes.bool
};

export default StoreForm;
